/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// THIS FILE IS GENERATED BY BUILD TOOL
// DO NOT EDIT IT MANUAL
import { wrapIcon } from '../../wrapIcon';
import { SVGProps } from 'react';
const SvgCellDoubleClickBase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.5 14.1711V2.98684M3.5 14.1711C3.5 14.7161 3.93911 15.1579 4.48077 15.1579H8.73077M3.5 14.1711V12.8553C3.5 12.3102 3.93911 11.8684 4.48077 11.8684M3.5 2.98684C3.5 2.44182 3.93911 2 4.48077 2H19.5192C20.0609 2 20.5 2.44182 20.5 2.98684V4.30263C20.5 4.84765 20.0609 5.28947 19.5192 5.28947M3.5 2.98684V4.30263C3.5 4.84765 3.93911 5.28947 4.48077 5.28947M4.48077 5.28947H19.5192M4.48077 5.28947H11.0192M4.48077 5.28947C3.93911 5.28947 3.5 5.7313 3.5 6.27632V7.59211C3.5 8.13712 3.93911 8.57895 4.48077 8.57895M19.5192 5.28947H12.9808M19.5192 5.28947C20.0609 5.28947 20.5 5.7313 20.5 6.27632V8.84211M4.48077 8.57895H9.25385M4.48077 8.57895C3.93911 8.57895 3.5 9.02077 3.5 9.56579V10.8816C3.5 11.4266 3.93911 11.8684 4.48077 11.8684M4.48077 11.8684H7.68462M12.9788 10.4211L14.0885 11.5375M16.8653 9.10501V10.684M11.6068 13.901H13.176M18.8468 22L17.8657 18.5325M17.8657 18.5325L16.0538 20.0541L16.4643 13.5789L20.2385 18.9923L17.8657 18.5325Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const SvgCellDoubleClick = wrapIcon(SvgCellDoubleClickBase);
export default SvgCellDoubleClick;
